import { Container, Stack, Title } from "@mantine/core";
import { useSearch } from "wouter";
import { useTranslation } from "react-i18next";
import DocumentGenerator from "./DocumentGenerator";

export default function DocumentsPage() {
  const { t } = useTranslation("Veft");
  const search = useSearch();
  const initialProjectId = new URLSearchParams(search).get("projectId");

  return (
    <Container size="md" py="md">
      <Stack gap="lg">
        <Title order={3}>{t("document_generation")}</Title>
        <DocumentGenerator
          projectId={initialProjectId}
          showGeneratedList
        />
      </Stack>
    </Container>
  );
}
